// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"PageFilterDropdownMenuStyle_dropdownMenu__AVGWH","option":"PageFilterDropdownMenuStyle_option__-ERfU"};